//export const add_Back = "http://localhost:4000";
//export const add_Front = "http://localhost:3000";

export const add_Back = "https://arcseedai.com:4000";
export const add_Front = "https://arcseedai.com";
